import { encryptedData } from '/@/utils/encrypt'
import request from '/@/utils/request'

export async function login(data: any) {
  // data = { ...data, password: await encryptedData(data) }

  return request({
    url: '/api/login/',
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/api/system/user/user_info/',
    method: 'get',
  })
}

export function logout(data) {
  return request({
    url: '/api/logout/',
    method: 'post',
    data
  })
}

export function register(data: any) {
  return request({
    url: '/register',
    method: 'post',
    data,
  })
}

export function getCodeImg() {
  return request({
    url: '/api/captcha/',
    method: 'GET',
    timeout: 20000,
  })
}

export function cacheMap(params: any) {
  return request({
    url: `/system/config/cache-map/${params.prefix}`,
    method: 'get',
  })
}

export function sendSms(data: any) {
  return request({
    url: '/auth/sms',
    method: 'post',
    data,
  })
}
//查询用户所属医院
export function listUserHospital(data?: any) {
  return request({
    url: `/auth/listUserHospital?username=${data.username}`,
    method: 'get',
    data,
  })
}
//切换医院
export function switchHospital(data: any) {
  return request({
    url: `/auth/switchHospital`,
    method: 'post',
    data,
  })
}

// 微信小程序一键登录
export function wechatMiniLogin(data: any) {
  return request({
    url: '/api/system/wx/wx_login',
    method: 'get',
    data,
  })
}
